import { SectionWithTitle } from 'src/app/components/Elements/SectionWithTitle';
import { MedicationCard } from 'src/app/components/Models/Medication/MedicationCard';
import type { HomePrescriptionItem, PrescriptionLifecycle } from 'src/app/types';

interface OverviewSectionProps {
  medicationDetailsPrescription: HomePrescriptionItem;
  prescriptionLifecycle?: PrescriptionLifecycle;
}

export const OverviewSection = ({ medicationDetailsPrescription, prescriptionLifecycle }: OverviewSectionProps) => {
  return (
    <SectionWithTitle sectionTitle="Overview">
      <MedicationCard
        isArchivedSection={false}
        homeScreenItem={medicationDetailsPrescription}
        prescriptionLifecycle={prescriptionLifecycle}
        hasMultiplePatients={false}
        showMenuActions={false}
        showRefillCount={true}
        showInstructions={true}
        showPatientName={true}
        showCheckout={true}
        showAddToBag={false}
        addTopMarginToAllCards={false}
        showArchiveButton={false}
        showDetailedStatusTracker={true}
        showPrescriptionDates={true}
        showCta={false}
      />
    </SectionWithTitle>
  );
};
